export type JobcardDetailField = {
  label: string;
  keys: string[];
};

/** Display order for the job card slip at top of Assign Employees modal */
export const JOBCARD_MANPOWER_DETAIL_FIELDS: JobcardDetailField[] = [
  { label: "Jobcard No.", keys: ["jobcard_no", "jobcardNo", "JobcardNo"] },
  { label: "Job date", keys: ["job_date", "jobDate", "Job_date"] },
  { label: "Customer", keys: ["customer_name", "customerName", "customername"] },
  { label: "Phone", keys: ["phone", "mobile", "Phone"] },
  {
    label: "Address",
    keys: ["address", "Address", "customer_address"],
  },
  { label: "Reg No.", keys: ["reg_no", "Reg_no", "regno", "platenumber"] },
  { label: "Vehicle make", keys: ["vehicle_make", "vehicleMake", "vmake"] },
  { label: "Model", keys: ["model", "model_year", "vehicletype", "vtype"] },
  { label: "Engine No.", keys: ["engine_no", "engineNo"] },
  { label: "Chassis No.", keys: ["chasis_no", "chasisNo", "chassis_no"] },
];

export function pickJobcardDetailValue(
  sources: Array<Record<string, unknown> | null | undefined>,
  keys: string[]
): string {
  for (const src of sources) {
    if (!src || typeof src !== "object") continue;
    for (const key of keys) {
      const v = src[key];
      if (v !== undefined && v !== null && String(v).trim() !== "") {
        return String(v).trim();
      }
    }
  }
  return "";
}

function formatJobcardDetailValue(label: string, raw: string): string {
  if (!raw) return "";
  if (label === "Job date") {
    const d = new Date(raw);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  }
  return raw;
}

export function buildJobcardDetailRows(
  sources: Array<Record<string, unknown> | null | undefined>
): Array<{ label: string; value: string }> {
  return JOBCARD_MANPOWER_DETAIL_FIELDS.map(({ label, keys }) => {
    const raw = pickJobcardDetailValue(sources, keys);
    const value = formatJobcardDetailValue(label, raw) || "—";
    return { label, value };
  }).filter((row) => row.value !== "—" || row.label === "Jobcard No.");
}
